__turbopack_context__.v({
  "divider": "gradientDivider-module-scss-module__xDdLFG__divider",
});
